






















import { Component, Vue, Prop } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import { IStyle } from '~/assets/interfaces/classes'

@Component({
  components: {
    ComponentIcon: () => import('~/components/icon/icon.vue'),
    ComponentLoadingSpinner: () => import('~/components/loading/spinner.vue'),
    LazyHydrate,
  },
})
export default class ComponentFormButtonIcon extends Vue {
  @Prop({ default: null, type: String }) readonly icon!: null
  @Prop({ default: 28, type: [Number, String] }) readonly size!: 28
  @Prop({ default: false, type: Boolean }) readonly loading!: boolean
  @Prop({ default: false, type: Boolean }) readonly primary!: boolean
  @Prop({ default: null, type: String }) readonly title!: string
  @Prop({ default: false, type: Boolean }) readonly outlinePrimary!: boolean

  private $style!: IStyle
  get classButton() {
    return {
      [this.$style.button]: true,
      [this.$style.primary]: this.primary,
      [this.$style.outlinePrimary]: this.outlinePrimary,
      [this.$style.default]: !this.primary && !this.outlinePrimary,
    }
  }

  get sizeRender(): string {
    return String(this.size ?? 28)
  }
}
